module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/mantova.2c78d9bc799affa24cc6d0b1f3f16e58.jpg";